'use client';

import { useEffect, useState } from 'react';

export function useIdleMount(timeoutMs = 2000): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof window.requestIdleCallback === 'function') {
      const id = window.requestIdleCallback(() => setReady(true), { timeout: timeoutMs });
      return (): void => {
        window.cancelIdleCallback(id);
      };
    }
    const id = window.setTimeout(() => setReady(true), 0);
    return (): void => {
      window.clearTimeout(id);
    };
  }, [timeoutMs]);

  return ready;
}
